import { gql, TypedDocumentNode } from '@apollo/client';

import {
  CreateUserSecretMutation,
  CreateUserSecretMutationVariables,
} from '../generated';

export const CREATE_USER_SECRET: TypedDocumentNode<
  CreateUserSecretMutation,
  CreateUserSecretMutationVariables
> = gql`
  mutation CreateUserSecret($input: CreateUserSecretInput!) {
    createUserSecret(input: $input) {
      id
      key
      description
      createdAt
      updatedAt
    }
  }
`;
